import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex justify-center items-center h-screen" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "px-6 py-4 text-left modal-content"
}
const _hoisted_5 = { class: "font-bold text-3xl mb-2 capitalize" }
const _hoisted_6 = { class: "text-xl mb-4 capitalize font-semibold" }
const _hoisted_7 = { class: "flex flex-wrap gap-2 mb-4" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["src"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["poster"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 2,
  class: "overflow-x-auto whitespace-nowrap flex gap-2 mb-2"
}
const _hoisted_14 = {
  key: 0,
  controls: "",
  class: "w-full h-96 object-cover rounded-md mb-2 border"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 3,
  class: "mt-8"
}
const _hoisted_19 = { class: "flex flex-col border rounded-md p-4 bg-gray-100 w-full" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "text-md font-semibold capitalize flex gap-3 items-center" }
const _hoisted_22 = {
  key: 1,
  class: "flex items-center gap-2 mt-2"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "text-xs text-gray-500" }
const _hoisted_25 = { class: "italic" }
const _hoisted_26 = {
  key: 0,
  class: "flex items-center gap-2 mt-4 mb-2"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "flex gap-2 mt-2" }
const _hoisted_29 = { class: "cursor-pointer px-6 py-3 mx-2 text-gray-400 rounded-lg bg-gray-200 hover:bg-gray-300 hover:text-gray-500" }
const _hoisted_30 = { class: "flex items-center justify-center gap-1 mb-4 px-2 py-1 bg-gray-200 rounded-md capitalize w-20 font-semibold" }
const _hoisted_31 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_32 = { class: "text-sm text-gray-500 mb-2" }
const _hoisted_33 = { class: "text-sm text-gray-500 mb-2" }
const _hoisted_34 = { class: "text-sm text-gray-500 mb-2" }
const _hoisted_35 = { class: "text-sm text-gray-500 mb-2" }
const _hoisted_36 = { class: "text-sm text-gray-500 mb-2" }
const _hoisted_37 = { class: "text-sm text-gray-500 mb-2" }
const _hoisted_38 = { class: "text-sm text-gray-500 mb-2" }
const _hoisted_39 = { class: "text-sm text-gray-500 mb-2" }
const _hoisted_40 = { class: "text-sm text-gray-500 mb-2" }
const _hoisted_41 = { class: "text-sm text-gray-500 mb-2" }
const _hoisted_42 = { class: "text-sm text-gray-500 mb-2 text-justify" }
const _hoisted_43 = {
  key: 0,
  class: "flex justify-end pt-2"
}
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "flex justify-end items-center gap-3 pt-2" }
const _hoisted_46 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_47 = { key: 2 }
const _hoisted_48 = { class: "flex justify-end items-center gap-3 pt-2" }

import { ref, watch, onMounted, computed } from "vue";
import axios from "axios";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import Swal from "sweetalert2";
import loader from "../../assets/loader.svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewTgModal',
  props: {
  id: {
    type: Number,
    required: true,
  },
  statuses: {
    type: Array,
    required: true,
  },
},
  setup(__props) {

const baseUrl = process.env.VUE_APP_BASE_URL;
const tg = ref({});
const props = __props;
const userRoleId = localStorage.getItem("user_role_id");
const statuses = ref([]);
const newComment = ref("");
const comments = ref([]);
const commentMedia = ref("");
const commentMediaPreview = ref("");
const isCommentUpdate = ref(false);
const updatedComment = ref("");
const isLoading = ref(true);

const formatDate = (date: string) => {
  if (date === null || date === undefined || date === "null") {
    return "N/A";
  } else {
    return new Date(date).toLocaleDateString();
  }
};

const formatDateTime = (date: string) => {
  if (date === null || date === undefined || date === "null") {
    return "N/A";
  } else {
    return new Date(date).toLocaleString();
  }
};

const fetchTg = async () => {
  if (!props.id) return;
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${baseUrl}/tour-guide/get-by-id/${props.id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    tg.value = response.data.data;
  } catch (error) {
    console.error(error);
  }
};

const updateTgStatus = async (status: string) => {
  const token = localStorage.getItem("token");

  const newStatus = props.statuses.find((s) => s.name === status);
  try {
    const response = await axios.post(
      `${baseUrl}/tour-guide/update`,
      {
        id: props.id,
        status_id: newStatus.id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (newStatus.name === "approved") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Tour guide has been approved successfully",
      });
    } else if (newStatus.name === "refused") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Tour guide has been refused successfully",
      });
    } else if (newStatus.name === "published") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Tour guide has been published successfully",
      });
    } else if (newStatus.name === "unpublished") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Tour guide has been unpublished successfully",
      });
    }
    await fetchTg();
  } catch (error) {
    console.error(error);
  }
};

const storeComment = async () => {
  const token = localStorage.getItem("token");
  const type = "tg";
  const blogId = props.id;
  try {
    const formData = new FormData();
    formData.append("content", newComment.value);
    if (commentMedia.value) {
      formData.append("media", commentMedia.value);
    }

    const response = await axios.post(`${baseUrl}/comment/store/${blogId}/${type}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Comment has been added successfully",
      });
      newComment.value = "";
      commentMedia.value = "";
      commentMediaPreview.value = "";
    }
    await fetchComments();
  } catch (error) {
    console.error(error);
  }
};

const fetchComments = async () => {
  const token = localStorage.getItem("token");
  const type = "tg";
  const blogId = props.id;
  try {
    const response = await axios.get(`${baseUrl}/comment/get/${blogId}/${type}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    comments.value = response.data.data.reverse();
  } catch (error) {
    console.error(error);
  }
};

const handleCommentMediaUpload = (event) => {
  const file = event.target.files[0];
  if (file) {
    commentMedia.value = file;

    // Generate a preview URL
    commentMediaPreview.value = URL.createObjectURL(file);
  }
};

const updateComment = async (commentId) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.put(
      `${baseUrl}/comment/update/${commentId}`,
      {
        content: updatedComment.value,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Comment has been updated successfully",
      });
      updatedComment.value = "";
      isCommentUpdate.value = false;
    }
    await fetchComments();
  } catch (error) {
    console.error(error);
  }
};

const isVideo = (index) => {
  try {
    const files = JSON.parse(tg.value.carousel);
    const file = files[index];
    return typeof file === "string" && file.match(/\.(mp4|webm|ogg)$/i);
  } catch (error) {
    console.error("Invalid JSON in tg.value.carousel:", error);
    return false;
  }
};

watch(
  () => props.id,
  async (newId) => {
    if (newId) {
      await fetchTg();
      await fetchComments();
      isLoading.value = false;
    }
  }
);

onMounted(async () => {
  await fetchTg();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _unref(loader),
              alt: "Loading...",
              class: "w-8 h-8"
            }, null, 8, _hoisted_3)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(tg.value.title), 1),
            _createElementVNode("h4", _hoisted_6, _toDisplayString(tg.value.subtitle), 1),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tg.value.tags, (tag) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: tag,
                  class: "px-2 py-1 bg-gray-200 rounded-md capitalize"
                }, _toDisplayString(tag.tag_name), 1))
              }), 128))
            ]),
            (tg.value.type_id === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("img", {
                    src: tg.value.thumbnail_image,
                    alt: "Thumbnail Preview",
                    class: "w-full h-96 object-cover border rounded-md mb-4 p-1"
                  }, null, 8, _hoisted_9)
                ]))
              : (tg.value.type_id === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("video", {
                      controls: "",
                      class: "w-full h-auto object-cover border rounded-md mb-4 p-1",
                      poster: tg.value.thumbnail_image
                    }, [
                      _createElementVNode("source", {
                        src: tg.value.banner_video,
                        type: "video/mp4"
                      }, null, 8, _hoisted_12)
                    ], 8, _hoisted_11)
                  ]))
                : (tg.value.type_id === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(tg.value.carousel), (image, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "shrink-0"
                        }, [
                          (isVideo(index))
                            ? (_openBlock(), _createElementBlock("video", _hoisted_14, [
                                _createElementVNode("source", {
                                  src: image,
                                  type: "video/mp4"
                                }, null, 8, _hoisted_15)
                              ]))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: image,
                                alt: 'Carousel Image ' + (index + 1),
                                class: "w-full h-96 object-cover border rounded-md mb-4 p-1"
                              }, null, 8, _hoisted_16))
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                class: "content",
                innerHTML: tg.value.body
              }, null, 8, _hoisted_17)
            ]),
            (tg.value.status?.name === 'pending' || tg.value.status?.name === 'approved' || tg.value.status?.name === 'published' || tg.value.status?.name === 'refused')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _cache[16] || (_cache[16] = _createElementVNode("hr", { class: "my-4" }, null, -1)),
                  _createElementVNode("div", null, [
                    _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-xl font-semibold" }, "Feedbacks and Notes", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comments.value, (comment) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: comment.id,
                        class: "flex items-center gap-2 mt-4 mb-2"
                      }, [
                        _createElementVNode("div", _hoisted_19, [
                          (comment?.media)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: comment.media,
                                target: "_blank",
                                class: "text-sm text-blue-500"
                              }, "📎 view attachment", 8, _hoisted_20))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", _hoisted_21, [
                            _createTextVNode(_toDisplayString(comment.content) + " ", 1),
                            (!isCommentUpdate.value)
                              ? (_openBlock(), _createElementBlock("svg", {
                                  key: 0,
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (isCommentUpdate.value = true)),
                                  xmlns: "http://www.w3.org/2000/svg",
                                  fill: "none",
                                  viewBox: "0 0 24 24",
                                  "stroke-width": "1.5",
                                  stroke: "currentColor",
                                  class: "w-4 h-4 cursor-pointer"
                                }, _cache[11] || (_cache[11] = [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                                  }, null, -1)
                                ])))
                              : _createCommentVNode("", true)
                          ]),
                          (isCommentUpdate.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((updatedComment).value = $event)),
                                  class: "w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                }, null, 512), [
                                  [_vModelText, updatedComment.value]
                                ]),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (updateComment(comment.id)),
                                  class: "px-2 py-1 text-white bg-blue-500 rounded-lg hover:bg-blue-700 duration-300 text-sm"
                                }, "Update", 8, _hoisted_23),
                                _createElementVNode("button", {
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (isCommentUpdate.value = false)),
                                  class: "px-2 py-1 text-white bg-red-500 rounded-lg hover:bg-red-700 duration-300 text-sm"
                                }, "Cancel")
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", _hoisted_24, [
                            _createTextVNode(_toDisplayString(comment.created_by.name) + " | " + _toDisplayString(formatDateTime(comment.created_at)) + " ", 1),
                            _createElementVNode("span", _hoisted_25, "(Updated at: " + _toDisplayString(formatDateTime(comment.updated_at)) + ")", 1)
                          ])
                        ])
                      ]))
                    }), 128)),
                    _cache[15] || (_cache[15] = _createElementVNode("hr", { class: "my-2" }, null, -1)),
                    (commentMediaPreview.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("img", {
                            src: commentMediaPreview.value,
                            alt: "Comment Media Preview",
                            class: "w-24 h-20 object-cover border rounded-sm mb-1 p-1"
                          }, null, 8, _hoisted_27),
                          _createElementVNode("button", {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (commentMediaPreview.value = '')),
                            class: "text-red-500 hover:text-red-700"
                          }, _cache[12] || (_cache[12] = [
                            _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              "stroke-width": "1.5",
                              stroke: "currentColor",
                              class: "w-6 h-6"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "M6 18L18 6M6 6l12 12"
                              })
                            ], -1)
                          ]))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newComment).value = $event)),
                        type: "text",
                        placeholder: "Add a comment...",
                        class: "w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
                        onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (storeComment()), ["enter"]))
                      }, null, 544), [
                        [_vModelText, newComment.value]
                      ]),
                      _createElementVNode("label", _hoisted_29, [
                        _cache[13] || (_cache[13] = _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          "stroke-width": "1.5",
                          stroke: "currentColor",
                          class: "w-6 h-6"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            d: "m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                          })
                        ], -1)),
                        _createElementVNode("input", {
                          type: "file",
                          accept: "image/*",
                          class: "hidden",
                          onChange: handleCommentMediaUpload
                        }, null, 32)
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (storeComment())),
                        class: "p-3 px-6 py-3 mr-2 text-white bg-blue-500 rounded-lg hover:bg-blue-700 hover:text-white focus:outline-none duration-300"
                      }, " Send ")
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _cache[23] || (_cache[23] = _createElementVNode("hr", { class: "my-8" }, null, -1)),
            _createElementVNode("div", _hoisted_30, [
              _cache[17] || (_cache[17] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                "stroke-width": "1.5",
                stroke: "currentColor",
                class: "h-5 w-5 text-gray-700"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                }),
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(tg.value.views), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", null, [
                  _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-lg font-semibold" }, "SEO", -1)),
                  _createElementVNode("p", _hoisted_32, "SEO title: " + _toDisplayString(tg.value.seo_title), 1),
                  _createElementVNode("p", _hoisted_33, "SEO description: " + _toDisplayString(tg.value.seo_description), 1),
                  _createElementVNode("p", _hoisted_34, "Canonical tag: " + _toDisplayString(tg.value.canonical_tag), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-lg font-semibold" }, "Blog", -1)),
                  _createElementVNode("p", _hoisted_35, "Category: " + _toDisplayString(tg.value.category?.name), 1),
                  _createElementVNode("p", _hoisted_36, "Type: " + _toDisplayString(tg.value.type?.name), 1),
                  _createElementVNode("p", _hoisted_37, [
                    _cache[19] || (_cache[19] = _createTextVNode(" Status: ")),
                    _createElementVNode("span", {
                      class: _normalizeClass([
                    tg.value.status?.name === 'published'
                      ? 'text-blue-500 bg-blue-100'
                      : tg.value.status?.name === 'approved'
                      ? 'text-green-500 bg-green-100'
                      : tg.value.status?.name === 'refused'
                      ? 'text-red-500 bg-red-100'
                      : 'text-amber-500 bg-amber-100'
                  , "inline-flex px-2 py-1 text-xs font-semibold leading-5 rounded-full"])
                    }, _toDisplayString(tg.value.status?.name), 3)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[21] || (_cache[21] = _createElementVNode("p", { class: "text-lg font-semibold" }, "Other", -1)),
                  _createElementVNode("p", _hoisted_38, "Created by: " + _toDisplayString(tg.value.created_by?.name), 1),
                  _createElementVNode("p", _hoisted_39, "Created at: " + _toDisplayString(formatDate(tg.value.created_at)), 1),
                  _createElementVNode("p", _hoisted_40, "Approved by: " + _toDisplayString(tg.value.approved_by || "N/A"), 1),
                  _createElementVNode("p", _hoisted_41, "Published at: " + _toDisplayString(tg.value.published_at || "N/A"), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-lg font-semibold" }, "Notes", -1)),
                  _createElementVNode("p", _hoisted_42, _toDisplayString(tg.value.notes), 1)
                ])
              ])
            ])
          ]),
          (_unref(userRoleId) === '2' && tg.value.status?.name === 'pending')
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (updateTgStatus('refused'))),
                  class: "p-3 px-6 py-3 mr-2 text-red-500 bg-transparent rounded-lg hover:bg-red-100 hover:text-red-400 focus:outline-none"
                }, " Refuse "),
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (updateTgStatus('approved'))),
                  type: "submit",
                  class: "px-6 py-3 font-medium tracking-wide text-white bg-indigo-600 rounded-md hover:bg-indigo-500 focus:outline-none"
                }, " Approve ")
              ]))
            : (_unref(userRoleId) === '2' && (tg.value.status?.name === 'approved' || tg.value.status?.name === 'unpublished'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _cache[24] || (_cache[24] = _createElementVNode("hr", { class: "my-4" }, null, -1)),
                  _createElementVNode("div", _hoisted_45, [
                    (tg.value.status?.name === 'unpublished')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_46, " This post was previously published but is currently unpublished. Click here to republish and make it visible to readers again. "))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (updateTgStatus('published'))),
                      type: "submit",
                      class: "px-6 py-3 font-medium tracking-wide text-white bg-green-600 rounded-md hover:bg-green-500 focus:outline-none"
                    }, " Publish ")
                  ])
                ]))
              : (_unref(userRoleId) === '2' && tg.value.status?.name === 'published')
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _cache[25] || (_cache[25] = _createElementVNode("hr", { class: "my-4" }, null, -1)),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("button", {
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (updateTgStatus('unpublished'))),
                        type: "submit",
                        class: "px-6 py-3 font-medium tracking-wide text-white bg-orange-500 rounded-md hover:bg-orange-600 focus:outline-none"
                      }, " Unpublish ")
                    ])
                  ]))
                : _createCommentVNode("", true)
        ]))
  ]))
}
}

})